export default "__VITE_ASSET__DT7j735O__"